import { render, staticRenderFns } from "./DashboardReseller.vue?vue&type=template&id=d9522732"
import script from "./DashboardReseller.vue?vue&type=script&lang=js"
export * from "./DashboardReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports